/**
 * Top-level keys whose values differ between two object snapshots (by JSON
 * value). Either side may be null — a null `before` (create) or null `after`
 * (delete) counts every present key as changed.
 *
 * Pure and dependency-free on purpose: both the server audit helper
 * (`@/lib/audit`) and the client audit viewer import it, and the viewer must not
 * pull server-only modules (drizzle/postgres) into the browser bundle.
 */
export function diffChanges(
  before: Record<string, unknown> | null | undefined,
  after: Record<string, unknown> | null | undefined,
): string[] {
  const keys = new Set<string>([...Object.keys(before ?? {}), ...Object.keys(after ?? {})]);
  const changed: string[] = [];
  for (const key of keys) {
    if (JSON.stringify(before?.[key] ?? null) !== JSON.stringify(after?.[key] ?? null)) {
      changed.push(key);
    }
  }
  return changed;
}
